import { type FlagOverrides, OverrideBehaviour, createFlagOverridesFromMap } from 'configcat-react';

/**
 * With flag overrides you can overwrite the feature flags & settings downloaded from the ConfigCat CDN with
 * local values. Moreover, you can specify how the overrides should apply over the downloaded values.
 * The following 3 behaviours are supported:
 *
 * Local only (OverrideBehaviour.LocalOnly): When evaluating values, the SDK will not use feature flags &
 * settings from the ConfigCat CDN, but it will use all feature flags & settings that are loaded from
 * local-override sources.
 *
 * Local over remote (OverrideBehaviour.LocalOverRemote): When evaluating values, the SDK will use all feature
 * flags & settings that are downloaded from the ConfigCat CDN, plus all feature flags & settings that are
 * loaded from local-override sources. If a feature flag or a setting is defined both in the downloaded and
 * the local-override source then the local-override version will take precedence.
 *
 * Remote over local (OverrideBehaviour.RemoteOverLocal): When evaluating values, the SDK will use all
 * feature flags & settings that are downloaded from the ConfigCat CDN, plus all feature flags & settings that
 * are loaded from local-override sources. If a feature flag or a setting is defined both in the downloaded and
 * the local-override source then the downloaded version will take precedence.
 *
 */
export const featureFlagOverrides: FlagOverrides = createFlagOverridesFromMap(
    {
        /**
         * You can load your feature flag & setting overrides from a simple
         * { [key: string]: boolean | string | number } map
         *
         * example:
         *
         * ```
         *   enabledFeature: true,
         *   disabledFeature: false,
         * ```
         */
        // enabledFeature: true,
        // disabledFeature: false,
    },
    OverrideBehaviour.RemoteOverLocal
);
